var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3756 8.47051L19.6519 0.0123291H17.9277L11.6096 7.35644L6.56338 0.0123291H0.743164L8.37403 11.1179L0.743164 19.9876H2.46753L9.13956 12.232L14.4687 19.9876H20.2889L12.3751 8.47051H12.3756ZM10.0138 11.2158L9.24064 10.1099L3.08884 1.3104H5.73736L10.7019 8.41188L11.4751 9.51775L17.9285 18.7486H15.2799L10.0138 11.2162V11.2158Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.579294187887e939c223c1121a8c5bd1.svg";
export { ForwardRef as ReactComponent };